'use strict';

import Cart             from "./components/cart";
import Checkout         from './components/Checkout.vue';
import ShippingAddress  from "./components/shipping-address";

export default class {

    constructor() {
      // Register components

      this.cart = new Cart();
      this.shippingAddress = new ShippingAddress();

      Vue.component('checkout', Checkout);

    }
}
